import { blacklistsConstants } from './blacklistsConstants';
import {userConstants} from "../../../auth/_redux/authConstants";

const makeInitialState = () => ({
  requestActive: false,
  requestSaveActive: false,
  shouldReload: true,
  items: [],
  logItems: [],
  rowsPerPage: 10,
  page: 1,
  sortBy: "id",
  sortDirection: "desc",
  startDate: null,
  endDate: null,
  total: 0,
  logTotal: 0,
  error: '',
  query: "",
  inProgress: true,
});

export function player_exclusion_blacklists(state = makeInitialState(), action) {
  switch (action.type) {
    case userConstants.LOGOUT:
      return makeInitialState();
    case blacklistsConstants.BLACKLISTS_LIST_REQUEST:
    case blacklistsConstants.BLACKLISTS_LOAD_REQUEST:
      return {
        ...state,
        requestActive: true,
        shouldReload: false,
        error: '',
        total: 0,
        logTotal: 0,
        inProgress: true,
      };
    case blacklistsConstants.BLACKLISTS_LIST_SUCCESS: {
      return {
        ...state,
        requestActive: false,
        shouldReload: false,
        items: action.blacklists.rows ? action.blacklists.rows : [],
        total: action.blacklists.total ? action.blacklists.total : 0,
        inProgress: false,
      };
    }
    case blacklistsConstants.BLACKLISTS_LOAD_SUCCESS: {
      return {
        ...state,
        requestActive: false,
        shouldReload: false,
        logItems: action.blacklists.rows ? action.blacklists.rows : [],
        logTotal: action.blacklists.total ? action.blacklists.total : 0,
        inProgress: false,
      };
    }
    case blacklistsConstants.BLACKLISTS_LIST_FAILURE:
      return {
        ...state,
        error: action.error,
        inProgress: false,
      };
    case blacklistsConstants.BLACKLISTS_LIST_CHANGED:
      return {
        ...state,
        shouldReload: true,
      };
    case blacklistsConstants.BLACKLISTS_LIST_PAGINATION: {
      let shouldReload = state.items.length === 0 ? true : false;

      if (state.rowsPerPage !== action.pagination.rowsPerPage
        || state.page !== action.pagination.page
        || state.sortBy !== action.pagination.sortBy
        || state.sortDirection !== action.pagination.sortDirection
        || state.query !== action.pagination.query
        || state.startDate !== action.pagination.startDate
        || state.endDate !== action.pagination.endDate
        || state.shouldReload) {
        shouldReload = true;
      }

      return {
        ...state,
        rowsPerPage: action.pagination.rowsPerPage,
        page: action.pagination.page,
        sortBy: action.pagination.sortBy,
        sortDirection: action.pagination.sortDirection,
        query: action.pagination.query,
        startDate: action.pagination.startDate,
        endDate: action.pagination.endDate,
        shouldReload
      };
    }

    case blacklistsConstants.BLACKLISTS_SAVE_REQUEST:
      return {
        ...state,
        requestSaveActive: true,
      }
    case blacklistsConstants.BLACKLISTS_SAVE_SUCCESS:
      if (action.isNew) {
        return {
          ...state,
          requestSaveActive: false,
          items: [...state.items, action.blacklists],
        }
      }
      return {
        ...state,
        requestSaveActive: false,
        items: state.items.map(t => t.id === action.blacklists.id ? action.blacklists : t)
      }
    case blacklistsConstants.BLACKLISTS_SAVE_FAILURE:
      return {
        ...state,
        requestSaveActive: false,
        error: action.error,
      }
    default:
      return state
  }
}
